import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const NODES = [
    { id: "in", x: 60, y: 90, label: "Inbox" },
    { id: "doc", x: 60, y: 210, label: "Documents" },
    { id: "read", x: 250, y: 150, label: "Understand" },
    { id: "route", x: 440, y: 90, label: "Route" },
    { id: "sys", x: 440, y: 210, label: "Systems" },
    { id: "team", x: 620, y: 150, label: "Your Team" },
];

const EDGES = [
    ["in", "read"],
    ["doc", "read"],
    ["read", "route"],
    ["read", "sys"],
    ["route", "team"],
    ["sys", "team"],
];

function nodeById(id) {
    return NODES.find((n) => n.id === id);
}

export default function WorkflowDiagram() {
    return (
        <div className="relative w-full text-foreground">
            <svg
                viewBox="0 0 700 300"
                fill="none"
                className="h-auto w-full"
                aria-hidden="true"
            >
                <defs>
                    <linearGradient id="flow" x1="0" y1="0" x2="1" y2="0">
                        <stop offset="0%" stopColor="hsl(var(--navy))" stopOpacity="0" />
                        <stop offset="50%" stopColor="hsl(var(--navy))" stopOpacity="1" />
                        <stop offset="100%" stopColor="hsl(var(--navy))" stopOpacity="0" />
                    </linearGradient>
                </defs>

                {/* edges */}
                {EDGES.map(([a, b], i) => {
                    const na = nodeById(a);
                    const nb = nodeById(b);
                    const d = `M ${na.x} ${na.y} C ${na.x + 70} ${na.y}, ${nb.x - 70} ${nb.y}, ${nb.x} ${nb.y}`;
                    return (
                        <g key={i}>
                            <motion.path
                                d={d}
                                stroke="currentColor"
                                strokeOpacity={0.14}
                                strokeWidth={1.5}
                                initial={{ pathLength: 0 }}
                                animate={{ pathLength: 1 }}
                                transition={{
                                    duration: 1.2,
                                    ease: EASE,
                                    delay: 0.6 + i * 0.12,
                                }}
                            />
                            <motion.path
                                d={d}
                                stroke="url(#flow)"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeDasharray="40 260"
                                initial={{ strokeDashoffset: 300 }}
                                animate={{ strokeDashoffset: [300, -300] }}
                                transition={{
                                    duration: 3.4,
                                    ease: "linear",
                                    repeat: Infinity,
                                    delay: 1.4 + i * 0.25,
                                }}
                            />
                        </g>
                    );
                })}

                {/* nodes */}
                {NODES.map((n, i) => (
                    <motion.g
                        key={n.id}
                        initial={{ opacity: 0, scale: 0.5 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.6, ease: EASE, delay: 0.5 + i * 0.1 }}
                    >
                        <motion.circle
                            cx={n.x}
                            cy={n.y}
                            r={18}
                            fill="hsl(var(--background))"
                            stroke="currentColor"
                            strokeOpacity={0.18}
                            strokeWidth={1.5}
                        />
                        <motion.circle
                            cx={n.x}
                            cy={n.y}
                            r={4}
                            fill="hsl(var(--navy))"
                            animate={{ opacity: [0.4, 1, 0.4] }}
                            transition={{
                                duration: 2.4,
                                repeat: Infinity,
                                ease: "easeInOut",
                                delay: i * 0.3,
                            }}
                        />
                        <text
                            x={n.x}
                            y={n.y + 38}
                            textAnchor="middle"
                            className="fill-muted-foreground font-mono"
                            style={{ fontSize: 11, letterSpacing: "0.05em" }}
                        >
                            {n.label}
                        </text>
                    </motion.g>
                ))}
            </svg>
        </div>
    );
}
